module.exports = require('./lib/effects')


//////////////////
// WEBPACK FOOTER
// ./~/redux-saga/effects.js
// module id = 36
// module chunks = 0